import { Link } from "react-router";
import { publications } from "~/src/data/publications";
import * as styles from "./Publications.module.css";

const publicationCards = publications.map((i) => (
  <Link
    className={styles.link}
    to={i.link}
    target="_blank"
    rel="noopener"
    key={crypto.randomUUID()}
  >
    {i.icon}
    <h3>{i.name}</h3>
  </Link>
));

export default function Publications() {
  return (
    <section className={styles.publicationSection}>
      <h2 id="publications" className={styles.heading}>
        Publications
      </h2>
      <div className={styles.cardsContainer}>{publicationCards}</div>
    </section>
  );
}
